// Opt-in: searchable selects (TomSelectInput, GroupedTomSelectInput).
import TomSelectController from './tom_select_controller'

export function register(application) {
  application.register('tom-select', TomSelectController)
}
